import {browserHistory} from 'react-router';

const initialState = {
    dataAvailable: false,
    rounds: [],
    currentRound: undefined,
    loadingLeaderboards: false,
    fullLeaderboards: [],
    partialLeaderboards: [],
    pageData: {},
    pageSet: {},
};

export default (state = initialState, action) => {

    switch (action.type) {
        case 'SELET_NEW_ROUND': {
            return {
                ...state,
                currentRound: action.payload,
            }
        }
        case 'GET_ALL_ROUNDS_START': {
            return {
                ...state,
                dataAvailable: false,
                rounds: [],
                currentRound: undefined,
            }
        }
        case 'GET_ALL_ROUNDS_FINISH': {

            const success = `${action.payload.errorCode}` === "0";
            const rounds = success && action.payload.intervals ?
                action.payload.intervals.filter(r => !r.removed) : [];

            rounds.forEach(r => {
                let startDate = new Date(r.start);
                let endDate = new Date(r.end);
                let now = new Date();
                r.voteOpen = startDate < now && endDate > now && r.enabled;
            });

            const nextOpenRound = rounds.find(r => r.voteOpen);
            const currentRound = rounds ? nextOpenRound ? nextOpenRound : rounds[rounds.length - 1] : undefined;

            return {
                ...state,
                dataAvailable: true,
                rounds,
                currentRound,
                data: action.payload,
            }
        }

        case 'GET_LEADERBOARDS_START': {
            return {
                ...state,
                loadingLeaderboards: true,
                fullLeaderboards: [],
                partialLeaderboards: [],
            }
        }
        case 'GET_LEADERBOARDS_FINISH': {
            return {
                ...state,
                loadingLeaderboards: false,
                fullLeaderboards: action.payload.fullLeaderboard,
                partialLeaderboards: action.payload.partialLeaderboards,
            }
        }
        case 'SUBMIT_VOTE_START': {
            return {
                ...state,
                submitting: true,
                submitted: false,
                submittedIdInterval: undefined,
                submittedIdVote: undefined,
                enabledSocialNetworks: undefined,
                createImageStatus: undefined
            }
        }
        case 'SUBMIT_VOTE_FINISH': {
            console.log("action.payload", action.payload);
            return {
                ...state,
                submitting: false,
                submitted: true,
                submittedIdInterval: action.payload.idInterval,
                submittedIdVote: action.payload.idVote,
                submittedIdImage: action.payload.idUploadedImage,
                enabledSocialNetworks: action.payload.enabledSocialNetworks,
                createImageStatus: action.payload.status
            }
        }
        case 'POST_ERROR': {
            return {
                ...state,
                submitting: false,
                submitted: false,
                submittedIdInterval: undefined,
                enabledSocialNetworks: undefined
            }
        }
        case 'GET_ACCEPTED_IMAGES_START': {
            return {
                ...state,
                loader: true
            }
        }
        case 'GET_ACCEPTED_IMAGES_FINISH': {

            let payload = action.payload;
            
            let pageSet = {
                isPrevEnabled: true,
                isNextEnabled: true
            };

            if (payload) {
                let total = payload.total;
                let limit = payload.limit;
                let pageCur = payload.page;

                if (!total || total <= (pageCur * limit)) {
                    pageSet.isNextEnabled = false;
                }

                if (pageCur <= 1) {
                    pageSet.isPrevEnabled = false;
                }

            }

            return {
                ...state,
                pageData: action.payload,
                pageSet,
                loader: false
            }
        }
        default:
            return state
    }
}
